module.exports = __webpack_public_path__ + "static/media/farm.45421c86.png";